// extracted by mini-css-extract-plugin
module.exports = {"text":"TitleH3_text__1j79J","center":"TitleH3_center__1JfoU"};